import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ToastState {
  message: string;
  severity: "success" | "error" | "warning" | "info" | "";
  open: boolean;
}

const initialState: ToastState = {
  message: "",
  severity: "success",
  open: false,
};

const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    setToast: (state, action: PayloadAction<ToastState>) => { 
      state.message = action.payload.message;
      state.severity = action.payload.severity;
      state.open = action.payload.open;
    },
  },
});

export const { setToast } = toastSlice.actions;
export default toastSlice.reducer;
